const firebaseConfig = {
    apiKey: "AIzaSyAHvrfJhtwFUZkPT-UIx4pTGV8NbonI0ng",
    authDomain: "brmc-official.firebaseapp.com",
    databaseURL: "https://brmc-official-default-rtdb.firebaseio.com",
    projectId: "brmc-official",
    storageBucket: "brmc-official.appspot.com",
    messagingSenderId: "181716080930",
    appId: "1:181716080930:web:3e37ac341fa860094eed7b"
  };
  export default firebaseConfig